import { useState } from 'react'
import { useApiClient } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export type HrInternalHoursExportParams = {
  startDate?: string
  endDate?: string
  users?: string
}

export const useHrInternalHoursExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const exportInternalHours = async ({
    startDate,
    endDate,
    users,
  }: HrInternalHoursExportParams) => {
    const queryParams = new URLSearchParams()

    if (startDate) queryParams.append('date_start', startDate)
    if (endDate) queryParams.append('date_end', endDate)
    if (users) queryParams.append('user', users)

    setLoading(true)
    try {
      const endpoint = '/hours_reporting/hr/internal-hours/export'

      const response = await client.get<Blob>(
        `${endpoint}?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { exportInternalHours, loading }
}
